import { render, staticRenderFns } from "./DishImages.vue?vue&type=template&id=22fb9b41&scoped=true"
import script from "./DishImages.vue?vue&type=script&lang=js"
export * from "./DishImages.vue?vue&type=script&lang=js"
import style0 from "./DishImages.vue?vue&type=style&index=0&id=22fb9b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb9b41",
  null
  
)

export default component.exports